import { Mock } from "../lib/appfuse-react/core/ajax";
import iamService from "../mock/iam";
import contentService from "../mock/content";
import applicationDraftService from "../mock/applicationDraft";
import questionnaireService from "../mock/questionnaire";
import inboxService from "../mock/inbox/inboxService";
import processingInboxService from "../mock/processingInbox";
import inspectionChecklistService from "../mock/inspectionChecklist/inspectionChecklistService";
import cropMarkApplicationService from "../mock/cropMarkApplication";
import processingMarkApplicationService from "../mock/processingMarkApplication";
import cropMarkDeclareService from "../mock/cropMarkDeclare";
import processingMarkDeclareService from "../mock/processingMarkDeclare";
import notificationService from "../mock/notification";
import processingMarkApplyRecordService from "../mock/processingMarkApplyRecords";
import cropMarkApplyRecordService from "../mock/cropMarkApplyRecords";
import cropCertificationDataDownloadService from "../mock/cropCertificationDataDownload";

const mock = (function() {
    const mock = new Mock();
    mock.use(iamService);
    mock.use(contentService);
    mock.use(applicationDraftService);
    mock.use(questionnaireService);
    mock.use(inboxService);
    mock.use(processingInboxService);
    mock.use(inspectionChecklistService);
    mock.use(cropMarkApplicationService);
    mock.use(processingMarkApplicationService);
    mock.use(cropMarkDeclareService);
    mock.use(processingMarkDeclareService);
    mock.use(notificationService);
    mock.use(processingMarkApplyRecordService);
    mock.use(cropMarkApplyRecordService);
    mock.use(cropCertificationDataDownloadService);
    return mock;
}());

const context = {mock};

export default context;

export {mock};